import { render, staticRenderFns } from "./leaderListFirst.vue?vue&type=template&id=34a3d4f9&scoped=true"
import script from "./leaderListFirst.vue?vue&type=script&lang=js"
export * from "./leaderListFirst.vue?vue&type=script&lang=js"
import style0 from "./leaderListFirst.vue?vue&type=style&index=0&id=34a3d4f9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a3d4f9",
  null
  
)

export default component.exports